import { getCommonExpenseApi, changeStatusOfCommonExpense } from '_services';
import { deleteCharOfAccountCategory } from '_services/accountingServices/accountingServices';
import { CommonInput } from 'components';
import BootstrapTable from 'components/BootstrapTable';
import { Images } from 'constants';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { AddTypeOfCategory, ConfirmModalFor } from 'modals';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { AiOutlineEye } from 'react-icons/ai';
import { FaRegTrashCan } from 'react-icons/fa6';
import { FiEdit } from 'react-icons/fi';
import { MdLock } from 'react-icons/md';
import { Link } from 'react-router-dom';
import StorageService from 'utils/StorageServices';

const ChartOfAccountCategory = () => {
    // Menu configuration with API parameters
    const menuConfig = {
        tripExpenses: {
            title: "Trip Expenses",
            items: [
                { id: 1, name: "Trip Charges", categoryId: 5, subCategoryId: 7 },
                { id: 2, name: "Trip Receipt", categoryId: 4, subCategoryId: 6 }
            ]
        },
        supplierDriverClaims: {
            title: "Supplier/Driver Claims",
            items: [
                { id: 3, name: "Charge Supplier/Driver", categoryId: 4, subCategoryId: 3 },
                { id: 4, name: "Pay Supplier/Driver", categoryId: 5, subCategoryId: 4 }
            ]
        },
        partyClaims: {
            title: "Party Claims",
            items: [
                { id: 5, name: "Pay Party", categoryId: 5, subCategoryId: 6 },
                { id: 6, name: "Charge Party", categoryId: 4, subCategoryId: 5 }
            ]
        },
        other: {
            title: "Other",
            items: [
                { id: 7, name: "Other Receipt", categoryId: 4, subCategoryId: 2 },
                { id: 8, name: "Other Expenses", categoryId: 5, subCategoryId: 3 }
            ]
        },
        expenses: {
            title: "Expenses",
            items: [
                { id: 9, name: "Vehicle Expenses", categoryId: 5, subCategoryId: 8 },
                { id: 10, name: "General Expenses", categoryId: 5, subCategoryId: 1 },
                { id: 11, name: "Salary", categoryId: 24, subCategoryId: 25 }
            ]
        },
        receipt: {
            title: "Receipt",
            items: [
                { id: 12, name: "Receipt", categoryId: 26, subCategoryId: 27 }
            ]
        }
    };

    const initialFilter = {
        search: ""
    };

    const [activeMenuItem, setActiveMenuItem] = useState(1);
    const [currentMenuData, setCurrentMenuData] = useState(menuConfig.tripExpenses.items[0]);
    const [commExpenseList, setCommExpenseList] = useState([]);
    const [filter, setFilter] = useState(initialFilter);
    const [checkboxStates, setCheckboxStates] = useState({});
    const [showModal, setShowModal] = useState(false)
    const [confirmModalShow, setConfirmModalShow] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);


    useEffect(() => {
        if (currentMenuData) {
            getCommonExpense(currentMenuData);
        }
    }, [currentMenuData]);

    const columns = [
        { header: "Category", accessor: "category" },
        { header: "Type", accessor: "type" },
        { header: "Status", accessor: "status" },
        { header: "Action", accessor: "action" }
    ];

    const handleCheckboxChange = (id) => {
        const newStatus = !checkboxStates[id];
        setCheckboxStates(prevStates => ({ ...prevStates, [id]: newStatus }));

        const object = {
            company_id: StorageService.getCompanyId(),
            account_id: id,
            active: Number(newStatus)
        };
        statusChangeOfExpense(object);
    };

    const statusChangeOfExpense = async (obj) => {
        // try {
        //   if (obj) {
        //     const res = await changeStatusOfCommonExpense(obj);
        //     if (res?.responseCode === 200) {
        //       toast.success(`${res?.responseMessage}`);
        //     } else {
        //       toast.error(res?.responseMessage);
        //       await getCommonExpense(currentMenuData);
        //     }
        //   }
        // } catch (error) {
        //   toast.error(error.message);
        //   await getCommonExpense(currentMenuData);
        // }
    };

    const handleEdit = (item,type) => {
        // Implement edit logic here
        console.log('Edit item:', item);
        setShowModal({...item,type:type})
    };

    const handleDelete = async (item) => {
        // Implement delete logic here
        console.log('Delete item:', item);
        try {
            setDeleteLoading(true)
            const res = await deleteCharOfAccountCategory({ account_id: item?._id })
            if (res?.responseCode == 200) {
                getCommonExpense(currentMenuData)
                setConfirmModalShow(false)
            }

        } catch (error) {

        } finally {
            setDeleteLoading(false)
        }

    };

    const rowListData = (data) => {
        return data?.map((item, i) => ({
            ...item,
            type: <>{item?.calculation_type === 1 ? "Fixed" : item?.calculation_type === 2 ? "Daywise" : "% of Revenue"}</>,
            category: (
                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    {item?.name ? item?.name : '-'}
                    {item?.is_manual == 0 && <MdLock />}
                </div>
            ),

            status: (
                <div className="_anvSwitcherNew form-check form-switch" style={{ width: "125px",cursor: item?.is_manual ? "pointer" : "not-allowed" }}>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        name="actStatus"
                        id={`actStatus-${item._id}`}
                        autoComplete="off"
                        checked={checkboxStates[item._id] || false}
                        onChange={() => handleCheckboxChange(item._id)}
                        disabled={!item?.is_manual}
                    />
                    <span className={checkboxStates[item._id] ? "active_label_masters_status" : "disabled_label_masters_status"}>
                        {checkboxStates[item._id] ? "Active" : "Disabled"}
                    </span>
                </div>
            ),
            // action: (
            //     <div className="_anvSwitcherNew form-check form-switch" style={{ width: "100px" }}>
            //         <button onClick={() => item?.is_manual ? handleEdit(item) : ""} className='_avPointer' style={{ background: "none" }} disabled={!item?.is_manual}>
            //             Edit
            //         </button>
            //         {' | '}
            //         <button onClick={() => item?.is_manual ? setConfirmModalShow(item) : ""} className='_avPointer' style={{ background: "none" }} disabled={!item?.is_manual}>
            //             Delete
            //         </button>
            //     </div>
            // ),
            action: (
                <div className="_anvSwitcherNew form-check form-switch" style={{ width: "100px", display: "flex", gap: "10px" }}>
                     <div
                        onClick={() => item?.is_manual ? handleEdit(item,"show") : null}
                        className="_avPointer"
                        style={{
                            background: "none",
                            opacity: item?.is_manual ? 1 : 0.4, // 👈 faded look
                            cursor: item?.is_manual ? "pointer" : "not-allowed", // 👈 disable hover
                        }}
                    >
                        <span className="_samAnchor">
                            <span className="editIcon_avt">
                                 {/* 👈 gray when disabled */}
                                 <AiOutlineEye color={item?.is_manual ? "green" : "gray"}/>
                            </span>
                        </span>
                    </div>
                    <div
                        onClick={() => item?.is_manual ? handleEdit(item,"Edit") : null}
                        className="_avPointer"
                        style={{
                            background: "none",
                            opacity: item?.is_manual ? 1 : 0.4, // 👈 faded look
                            cursor: item?.is_manual ? "pointer" : "not-allowed", // 👈 disable hover
                        }}
                    >
                        <span className="_samAnchor">
                            <span className="editIcon_avt">
                                <FiEdit color={item?.is_manual ? "blue" : "gray"} /> {/* 👈 gray when disabled */}
                            </span>
                        </span>
                    </div>

                    <div
                        onClick={() => item?.is_manual ? setConfirmModalShow(item) : null}
                        className="_avPointer"
                        style={{
                            background: "none",
                            opacity: item?.is_manual ? 1 : 0.4,
                            cursor: item?.is_manual ? "pointer" : "not-allowed",
                        }}
                    >
                        <span className="_samAnchor">
                            <span className="deleteIcon_avt">
                                <FaRegTrashCan color={item?.is_manual ? "red" : "gray"} />
                            </span>
                        </span>
                    </div>
                </div>
            ),

        }));
    };

    const getCommonExpense = async (menuData) => {
        try {
            const payload = {
                company_id: StorageService.getCompanyId(),
                category_id: menuData.categoryId,
                sub_category_id: menuData.subCategoryId,
            };
            const res = await getCommonExpenseApi(payload);

            if (res?.responseCode === 200) {
                const details = res?.data?.categories?.map((item) => {
                    return {
                        ...item,
                        label: item?.name,
                        value: item?._id,
                    };
                });
                setCommExpenseList(details);

                // Initialize checkbox states from API data
                const initialCheckboxStates = {};
                details.forEach(item => {
                    initialCheckboxStates[item._id] = item.status === 1 || item.status === true;
                });
                setCheckboxStates(initialCheckboxStates);
            }
        } catch (error) {
            toast.error('Failed to load expenses');
        }
    };

    const handleSearchChange = (e) => {
        setFilter({ ...filter, [e.target.name]: e.target.value });
    };

    // Filter data based on search
    const filteredData = commExpenseList?.filter(item => {
        const searchTerm = filter.search.toLowerCase();

        // Get the type text
        const typeText = item?.calculation_type === 1 ? "fixed" :
            item?.calculation_type === 2 ? "daywise" :
                "% of revenue";

        // Search in name or type
        const matchesName = item?.name?.toLowerCase().includes(searchTerm);
        const matchesType = typeText.includes(searchTerm);

        return matchesName || matchesType;
    }) || [];

    const handleMenuItemClick = (item) => {
        setActiveMenuItem(item.id);
        setCurrentMenuData(item);
        setFilter(initialFilter); // Reset filter when changing menu
    };

    const callbackHnadle = () => {
        setShowModal(false)
        getCommonExpense(currentMenuData);
    }

    useDocumentTitle("Chart of Accounts | T360");

    const typeProps = {
        headerPart: false,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: `Add Category`,
        submitTitle: `Add`,
        isOpen: showModal,
        closeModal: () => setShowModal(false),
        callbackHnadle: callbackHnadle,
        currentMenuData: currentMenuData
    }

    let confirmModalProps = {
        show: confirmModalShow,
        closeModal: (e) => {
            setConfirmModalShow(false);
        },
        title: "Confirm",
        submitTitle: "Delete",
        onSubmit: () => handleDelete(confirmModalShow),
        confirmModal: "confirmModal",
        icon: Images.DELETEICON.default,
        isLoadding: deleteLoading,
        disabled: deleteLoading,
    };

    return (
        <>
            {/* FOR CHART OF ACCOUNTS */}
            <div className='__charMain_bx'>
                <div className='__char_flx'>
                    <div className='__charLeft'>
                        <div className='__charHeads'>
                            <h4>Chart of Accounts</h4>
                        </div>

                        <div className='__charMenu_mx'>
                            {/* Trip Expenses */}
                            <div className='__charInnr_bx'>
                                <h2>{menuConfig.tripExpenses.title}</h2>
                                <ul>
                                    {menuConfig.tripExpenses.items.map((item) => (
                                        <li key={item.id}>
                                            <Link
                                                className={activeMenuItem === item.id ? '__chrActive' : ''}
                                                onClick={() => handleMenuItemClick(item)}
                                            >
                                                {item.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Supplier/Driver Claims */}
                            <div className='__charInnr_bx'>
                                <h2>{menuConfig.supplierDriverClaims.title}</h2>
                                <ul>
                                    {menuConfig.supplierDriverClaims.items.map((item) => (
                                        <li key={item.id}>
                                            <Link
                                                className={activeMenuItem === item.id ? '__chrActive' : ''}
                                                onClick={() => handleMenuItemClick(item)}
                                            >
                                                {item.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Party Claims */}
                            <div className='__charInnr_bx'>
                                <h2>{menuConfig.partyClaims.title}</h2>
                                <ul>
                                    {menuConfig.partyClaims.items.map((item) => (
                                        <li key={item.id}>
                                            <Link
                                                className={activeMenuItem === item.id ? '__chrActive' : ''}
                                                onClick={() => handleMenuItemClick(item)}
                                            >
                                                {item.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Other */}
                            <div className='__charInnr_bx'>
                                <h2>{menuConfig.other.title}</h2>
                                <ul>
                                    {menuConfig.other.items.map((item) => (
                                        <li key={item.id}>
                                            <Link
                                                className={activeMenuItem === item.id ? '__chrActive' : ''}
                                                onClick={() => handleMenuItemClick(item)}
                                            >
                                                {item.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Expenses */}
                            <div className='__charInnr_bx'>
                                <h2>{menuConfig.expenses.title}</h2>
                                <ul>
                                    {menuConfig.expenses.items.map((item) => (
                                        <li key={item.id}>
                                            <Link
                                                className={activeMenuItem === item.id ? '__chrActive' : ''}
                                                onClick={() => handleMenuItemClick(item)}
                                            >
                                                {item.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Receipt */}
                            <div className='__charInnr_bx'>
                                <h2>{menuConfig.receipt.title}</h2>
                                <ul>
                                    {menuConfig.receipt.items.map((item) => (
                                        <li key={item.id}>
                                            <Link
                                                className={activeMenuItem === item.id ? '__chrActive' : ''}
                                                onClick={() => handleMenuItemClick(item)}
                                            >
                                                {item.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className='__charRight'>
                        <div className='__chrHead'>
                            <div className='__chrFr_head'>
                                <h4>{currentMenuData?.name || 'Chart of Accounts'}</h4>
                                {(currentMenuData?.id !== 11 && currentMenuData?.id !== 12) && <button className='anime-btn __chr_addNewBtn' onClick={() => setShowModal(true)}>+ Add New</button>}
                            </div>

                            <div className='__charFilts'>
                                <div className='__searchChar'>
                                    <CommonInput
                                        type="text"
                                        placeholder={`Search ${currentMenuData?.name || ''}`}
                                        label={`Search ${currentMenuData?.name || ''}`}
                                        name='search'
                                        value={filter.search}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='__chrBody'>
                            {/* <div className='_tabWith_outTab'> */}
                            <BootstrapTable
                                tableClass="__charSideTable"
                                columns={columns}
                                data={rowListData(filteredData)}
                            />
                            {/* </div> */}
                        </div>
                    </div>
                </div>
            </div>
            {/* FOR CHART OF ACCOUNTS */}

            <AddTypeOfCategory {...typeProps} />
            {confirmModalShow && (
                <ConfirmModalFor {...confirmModalProps}>
                    <>
                        <p className="_confirmPrx">
                            {" "}
                            Are you sure you want to delete this Category"
                        </p>
                    </>
                </ConfirmModalFor>
            )}
        </>
    );
};

export default ChartOfAccountCategory;